import { useState, useMemo } from 'react';
import { useQueryParams } from '@/hooks';
import { CommerceFilters, CommerceStatus } from '../models';

const TEXT_FILTERS = [
  'name',
  'businessName',
  'externalId',
  'sellerId',
  'taxNumber',
  'email',
  'phone',
] as const;

export function useCommercesFilter() {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: CommerceFilters = useMemo(
    () => ({
      ...Object.fromEntries(TEXT_FILTERS.map((key) => [key, ''])),
      status: undefined,
    }),
    []
  );

  const [filters, setFilters] = useState<CommerceFilters>(() => ({
    ...Object.fromEntries(
      TEXT_FILTERS.map((key) => [key, getQueryParam(key) || ''])
    ),
    status: (getQueryParam('status') as CommerceStatus) || initialFilter.status,
  }));

  const updateFilters = (newFilters: CommerceFilters) => {
    setFilters(newFilters);
    setQueryParams({
      ...Object.fromEntries(
        TEXT_FILTERS.map((key) => [key, newFilters[key] || undefined])
      ),
      status: newFilters.status || undefined,
    });
  };

  return {
    filters,
    setFilters: updateFilters,
    initialFilter,
  };
}
